"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiInfo = void 0;
const utils_1 = require("@dev-stream/utils");
const utils_2 = require("@dev-stream/utils");
const contact_1 = require("./contact");
const license_1 = require("./license");
class OpenApiInfo extends utils_1.BaseModel {
    constructor() {
        super(...arguments);
        this.BASE_TYPE = OpenApiInfo;
    }
    GetDefaultValue() {
        return {
            title: "",
            version: "",
        };
    }
    static isOpenApiInfo(obj) {
        return (obj instanceof OpenApiInfo ||
            (0, utils_2.hasUnionKeysStrict)(obj, ["title", "version"]));
    }
}
__decorate([
    (0, utils_1.Property)(() => contact_1.OpenApiContact)
], OpenApiInfo.prototype, "contact", void 0);
__decorate([
    (0, utils_1.Property)(() => license_1.OpenApiLicense)
], OpenApiInfo.prototype, "license", void 0);
exports.OpenApiInfo = OpenApiInfo;
